import { api } from './api';
import URI from './URI';

export const getFundLimit = () => {
  return api(
    URI.fundLimit,
    {
      method: 'GET',
      tokenRequired: true,
      headers: {
        source: 'WEB',
      },
    },
    import.meta.env.VITE_STOCK_API_BASE
  );
};
